import api from "@/config/apiConfig"

class UsersController {

  async index ( req ) {
    try {
      const response = await api.get("/users", { params: { ...req }});
      return response.data;
    } catch ( error ) {
      console.error( "Erro no UsersController.index: ", error );
      throw error;
    }
  }
  async create ( req ) {
    try {
      const response = await api.post( `/users`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no UsersController.create: ", error );
      throw error;
    }
  }
  async update ( req ) {
    try {
      const response = await api.patch( `/users/${ req.id }`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no UsersController.update: ", error );
      throw error;
    }
  }
  async delete ( req ) {
    try {
      const response = await api.delete( `/users/${ req }` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no UsersController.delete: ", error );
      throw error;
    }
  }
  async uploadPicture ( id, file ) {
    try {
      const formData = new FormData();
      formData.append( "file", file );
      const response = await api.post( `/users/${ id }/upload-picture`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      return response.data;
    } catch ( error ) {
      console.error( "Erro no UsersController.uploadPicture: ", error );
      throw error;
    }
  }
  async removePicture ( id ) {
    try {
      const response = await api.delete( `/users/${ id }/upload-picture` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no UsersController.removePicture: ", error );
      throw error;
    }
  }
}

export default new UsersController();